import Api from './api';
import Types from './types';
import { appConfig } from '../services';

export default class Lang {
    _translateSource = {};
    _api = null;
    _lang = appConfig.defines.APP_LANG;

    get name() {
        return this._lang;
    }

    _dateLangReplace = {
        "ar": "en"
    };

    constructor(api) {
        if (!(api instanceof Api)) {
            throw new Error('api provider incompatible');
        }
        this._api = api;
        this.languages = Object.keys(Types.LANGUAGES);
    }

    init(lang) {
        if (typeof lang === "string") {
            lang = lang.toLowerCase();
        }

        return new Promise((resolve, reject) => {
            if ((this._lang === lang && Object.keys(this._translateSource).length > 0)
                || typeof lang === 'undefined'
            ) {
                resolve();
                return;
            }

            this._api.get(appConfig.defines.LANG_URL + lang + ".json",
                {
                    options: { timeout: 10000 }
                })
                .then((response) => {
                    this._lang = lang;
                    this._translateSource = response.data;

                    resolve();
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    /**
     *
     * @param text
     * @param data {object|null} объект для подстановки значение в "маркеры" перевода
     * @returns {*}
     */
    t(text, data = null) {
        if (typeof (this._translateSource[text]) !== "undefined") {
            text = this._translateSource[text];
        }

        if (data === null) {
            return text;
        }

        Object.keys(data).forEach((key) => {
            text = text.replace(new RegExp('{' + key + '}', 'g'), data[key]);
        });

        return text;
    }
}